import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import PushNotificationService from '../Services/PushNotificationService';
import {extractErrorMessage} from '../Services/RequestService';

export const usePushNotifications = () => {
    const [, setSubscription] = useState(null);
    const token = localStorage.getItem("token");
    const {setError} = useContext(ErrorContext);

    const register = async () => {
        try {
            let subs = await PushNotificationService.registerPushNotifications(token);
            setSubscription(subs);
        }catch(e){
            setError(extractErrorMessage(e));
            throw e;
        }
    }

    useEffect(() => {
        register()
    }, []);

    return [];
}


// WEBPACK FOOTER //
// ./src/Hooks/usePushNotifications.js